<template>
  <div class="page b2 text-left">
    <div class="item-wrap b1 mx-20 mt-20">
      <div class="title flex items-center justify-center s7 t5">大赛介绍</div>
      <div class="content s6 t1 mt-38">
        有看投+
        模拟炒股回归赛，由广大A股投资者和具有专业投顾资格的券商投资顾问共同参加。大赛旨在为参赛者提供一个展现风采、相互切磋的平台，也为广大投资者与投顾沟通并观摩学习提供一个平台。比赛由第一财经旗下“有看投+”APP独立组织及运营，与苹果公司及各手机应用平台等第三方公司无关。
      </div>
    </div>
    <div class="item-wrap b1 mx-20 mt-20">
      <div class="title flex items-center justify-center s7 t5">比赛说明</div>
      <div class="content s6 t1 mt-38">
        1、报名比赛：限“有看投+”APP注册用户参与；<br />
        2、比赛时间：2021年10月—2021年12月，总周期为3个自然月；<br />
        3、排行榜：比赛含有收益榜、民间榜和专业榜3个榜单；收益榜按日收益率、周收益率、月收益率和总盈利进行排名；<br />
        3-1、月收益率榜：按所有参赛者月度持仓收益率排名，若月收益率相同，将按月总资产进行排名；若月总资产额相同，则按报名参赛时间先后顺序进行排名；（当月无持仓记录的选手不参与排名）<br />
        3-2、总盈利排行榜：按所有参赛者的持仓总盈利额进行排名，若总盈利额相同，将按报名参赛时间先后顺序进行排名；（整个赛期无持仓记录的选手不参与排名）<br />
        4、成绩公布：每个交易日收盘结算后，日/周/月榜按选手的比赛持仓收益率进行排名；总盈利榜按选手的比赛持仓总盈利额进行排名。<br />
        5、专业组选手限券商持牌投资顾问，民间组选手资格不限。参赛投顾公布真实姓名、所属券商和营业部。民间榜可自由选择是否公开真实身份信息。<br />
        5-1、专业选手：参赛选手须下载 “有看投”APP<br />
        及微信大咖端小程序并注册，注册资料同报名资料。专业榜投顾由第一财经完成报名审核。<br />
        5-2、民间选手：参赛选手须下载 “有看投”APP并免费注册。<br />
        6、参赛选手可实时查询本人模拟股票账户、资金账户、委托成交、买卖历史记录、当日排行榜等情况，也可对尚未成交的委托撤单。<br />
        7、用户参加有看投+模拟炒股大赛产生的收益排名、交易数据等内容，版权归大赛主办方所有。<br />
      </div>
    </div>
    <div class="item-wrap b1 mx-20 mt-20">
      <div class="title flex items-center justify-center s7 t5">奖励细则</div>
      <div class="content s6 t1 mt-38">
        1、月度奖励：比赛最终按月收益率榜进行排名，取每个自然月的收益榜前10名进行奖励。<br />
        月收益率榜奖励：<br />
        第1名：10888元"金牛"大奖<br />
        第2-3名：3188元"银牛"大奖<br />
        第4-10名：1188元"铜牛"大奖<br />
        2、特别奖项：为更好地体现用户持续的收益表现，有看投+新增设立年度大奖，依据用户全年各月度的比赛表现，取全年总盈利额前3名进行奖励。<br />
        总盈利榜奖励: <br />
        第1名：11888元年度"金牛"大奖<br />
        第2名：8888元年度"银牛"大奖<br />
        第3名：5888元年度"铜牛"大奖<br />
        【因领取奖金产生的个人所得税将由税务局系统自动扣除，具体扣税比例请参照税务局网站】<br />
        关于本次比赛的奖项设计、奖品和奖金的发放均由有看投+
        APP独立组织，与苹果公司无关，比赛规则最终解释权归第一财经有看投+
        项目组。<br />
      </div>
    </div>
    <div class="item-wrap b1 mx-20 mt-20">
      <div class="title flex items-center justify-center s7 t5">交易规则</div>
      <div class="content s6 t1 mt-38">
        1、初始资金：100万元整。<br />
        2、交易费用：A股印花税0.1%，卖出收取；佣金0.05%，双向收取，包含过户费。配股不收取佣金、印花税及过户费，配股后卖出执行通用交易费用规则。<br />
        3、交易品种：支持深圳、上海证券交易所上市的A股、科创板、创业板、场内ETF和LOF基金；暂不支持st、*st和退市整理期的股票、首日上市的新股、北交所和新三板股票、B股、分级基金和债券。如已持有股票变成ST、*ST或进入退市整理期的个股，只能卖出，收益计入成绩。若用户买入ST、*ST或进入退市整理期个股，则视为违规，将取消其账户内所有成绩。<br />
        4、支持A股分红、派息、送股和配股，比例根据交易所公布的公告来执行；不支持新股申购、增发、基金分拆、合并、融资融券等业务。<br />
        5、交易买卖 5-1、交易时间：每个交易日9：30-11：30和13：00－15：00<br />
        5-2、交易日清算时间不接受下单委托；非交易时间，参赛选手的委托将进入下一次开市后的撮合；（赛期最后一个交易日收盘后不接受委托）<br />
        5-3、清算时间：每个交易日15:00-17:00（具体以实际清算时长为准），清算时间内不接受下单委托；（当日未成交的委托单在日中清算时自动撤销）<br />
        5-4、交易单位：买入/卖出股票，申报数量应当为100股(份)或其整数倍，A股的申报价格最小变动单位为0.01元人民币。<br />
        5-5、单个股票限额：30%规则，即单只个股持仓量不能超过当时总资产的30%。<br />
        6、交易制度 6-1、实行T+1交易制度 6-2、不支持集合竞价和部分成交<br />
        6-3、买入成交：买入委托价大于等于卖一价，按照卖一价成交；<br />
        6-4、卖出成交：卖出委托价小于等于买一价，按照买一价成交；<br />
        7、涨跌停股票特殊规则<br />
        7-1、涨停板的股票，以涨停价委托的单子，如果涨停打开，卖一价有委托单，即可成交；涨停板不打开，不成交。<br />
        7-2、跌停板的股票，以跌停价委托的单子，如果跌停打开，买一价有委托单，即可成交；跌停板不打开，不成交。<br />
        8、清算交割<br />
        8-1、用户委托买入时，其账号上的可用资金金额相应减少（冻结），在买单成交时系统自动清算交割，并且计入交易费用。<br />
        8-2、委托卖出时，其账号上的股票立即被减少可卖数，可用资金额暂不增加，只有等待股票卖出成功时系统自动清算交割，资金数量才会被刷新，并且计入交易费用。<br />
        9、派息、送股与配股规则<br />
        9-1、领取方式：自动划到比赛选手的参赛帐户上，可在对持仓详情中中查看股息到账情况<br />
        9-2、领取时间：R日到账(R：除权除息日)<br />
        9-3、根据国家税收有关规定，上市公司利润分派需征收10%的所得税，系统将代扣税款。<br />
        9-4、配股方式：股权登记日以后的十日内以账户现有资金自动配股，十日内没有资金则视为放弃。新配股份可在除权日日终清算时股份入账。<br />
        10、专业组操作不得买入自己所在机构产品和现实客户的标的股。不得利用内幕消息作为交易的依据，违者需承担由此引发的现实和法律风险，出现此类情况，取消成绩。<br />
        11、如发现系统存在漏洞，主办方将予以核实，对故意利用漏洞获利的选手，主办方有权利取消其参赛成绩。<br />
        12、特殊风险声明：分红配股风险提示——由于任何一家数据提供商都无法完全保证分红、送股、配股数据的准确性，因此主办方也无法保证这部分数据真实准确。由此造成的选手损失，主办方尽可能恢复数据，但无法保证数据可以完全恢复。<br />
        13、特殊故障风险提示：如果系统发生软硬件故障，导致模拟交易系统的运行处于非正常状态，主办方有权暂停有关操作，并对异常时期内的买卖操作进行相应的处置；原则上异常交易数据将被重置回当日或前一日开盘前状态。<br />
        14、注意事项：参赛选手必须保护好自己的相关密码，如因为密码丢失或被破解所导致的账户被窃而造成损失的，大赛主办方和指定交易商不负任何责任；由于参赛选手众多，系统有可能会在某些特定时间(如开赛第一天)处理成交缓慢，或无法撤单等系统问题，敬请谅解。<br />
        15、免责条款：主办方本着勤勉尽职的态度尽力保证大赛顺利进行，但由于存在不可抗力因素、系统故障或通信网络状况可能问题，对参赛选手收益率及排名产生的影响不做担保；如果系统发生软硬件故障，导致模拟炒股交易的运行处于非正常状态，主办方有权暂停有关操作，并对异常时间内的买卖操作进行相应的处置。<br />
        16、本规则未规定事项，与证券交易所交易规则一致。<br />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  defineComponent,
  onMounted,
  reactive,
  toRefs
} from '@vue/composition-api'
import { getClientInfo, updateTitle } from '@em/ym'

export default defineComponent({
  components: {},
  setup() {
    const state = reactive({
      activeIndex: 0,
      status: 1,
      fundPositions: null
    })
    onMounted(() => {
      getClientInfo().finally(() => {
        updateTitle('赛事说明')
      })
    })

    return { ...toRefs(state) }
  }
})
</script>

<style lang="scss" scoped>
.page {
  line-height: 1.36;
  text-align: left;
}
.page {
  .flex {
    display: flex;
  }
  .items-center {
    align-items: center;
  }
  .justify-center {
    justify-content: center;
  }
  .items-start {
    align-items: flex-start;
  }
  .justify-between {
    justify-content: space-between;
  }
  .text-left {
    text-align: left;
  }
  .flex-auto {
    flex: auto;
  }
  .mb-150 {
    margin-bottom: 150px;
  }
  .py-38 {
    padding-top: 38px;
    padding-bottom: 38px;
  }
  .px-20 {
    padding-left: 20px;
    padding-right: 20px;
  }
  .px-40 {
    padding-left: 40px;
    padding-right: 40px;
  }
  .mb-40 {
    margin-bottom: 40px;
  }
  .mx-20 {
    margin-left: 20px;
    margin-right: 20px;
  }
  .ml-15 {
    margin-left: 15px;
  }
  .mt-12 {
    margin-top: 12px;
  }
  .mt-8 {
    margin-top: 8px;
  }
  .my-36 {
    margin-top: 36px;
    margin-bottom: 36px;
  }
  .pt-1 {
    padding-top: 1px;
  }
  .text-center {
    text-align: center;
  }
}
.item-wrap {
  padding: 40px;
  border-radius: 15px;
  .title {
    position: relative;
    left: -60px;
    width: 193px;
    height: 67px;
    background: url('./images/title.png') no-repeat;
    background-size: cover;
  }
}
</style>
